import React from "react";

function InputDatoProdottoNumero(props) {
        
    //const prodottoTemp=props.prodottoTemp;
    const inputLabel=props.inputLabel;
    const datoName=props.datoName;
    const datoId=props.datoId;
    const datoValue=props.datoValue;
    const datoPlaceHolder=props.datoPlaceHolder;
    const datoOnChange= props.datoOnChange;
    const datoClass= props.datoClass;
    const classiTastoSblocco = props.classiTastoSblocco;
    const tastoCopiaAspetto = props.tastoCopiaAspetto;
    const tooltip = props.tooltip;

    
    
    
    
    
    return (
        <div className="mb1">
            <label for={datoId}
                className="pointer" 
                onClick={(e) => navigator.clipboard.writeText(datoValue).then(e.preventDefault())}
            >{inputLabel}</label>{tooltip && <span className="ml1 gray pointer" title={tooltip} aria-label={tooltip}>ⓘ</span>}<br />
                        <input
                            type="text"
                            id={datoId}
                            placeholder={datoPlaceHolder}
                            name={datoName}
                            value={datoValue}
                            autoComplete="off"
                            onChange={datoOnChange}
                            className={datoClass}
                        />                        
            <button onClick={(e) => navigator.clipboard.writeText(datoValue).then(e.preventDefault())} className={classiTastoSblocco}>{tastoCopiaAspetto}</button> 
        </div>
    )



}

export default InputDatoProdottoNumero;